export default __webpack_public_path__ + "static/5-d37e2a5efa1f74b0cc84eacc35f4481f.jpg";